export enum ResetPasswordRequestError {
  UserNotFound,
  Unknown
}
